







































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { Trade } from '@/models/trade';
import type { Phase } from '@/models/phase';
import type { Lesson } from '@/models/lesson';
import type { Worksheet } from '@/models/worksheet';
import type { Project } from '@/models/project';

import { tradeWorksheetWebservice } from '@/webservices/tradeWorksheet';
import type { Topic } from '@/models/topic';
import { topicWebservice } from '@/webservices/topic';
import { ApprovalState } from '@/components/prine/enums/ApprovalState';
import PrineButton from '@/components/prine/PrineButton.vue';
import LessonsList from '@/components/knowledge/lessons/LessonsList.vue';
import UpdateFilter from '@/components/worksheets/UpdateFilter.vue';
import { filterLessonContainer, filterLessons } from '@/helpers/filter/lessons/lessonsFilter';
import { LessonsFilter } from '@/helpers/types/LessonsFilter';
import { extractTagsFrom } from '@/helpers/extractTags';
import { allInLessonContainersSelected } from '@/helpers/filter/lessons/allInLessonContainersSelected';
import { deselectAll, selectAll } from '@/helpers/filter/lessons/selectAll';

@Component({
    name: 'UpdateWorksheetTrade',
    methods: { extractTagsFrom, filterLessons },
    components: {
        UpdateFilter,
        PrineButton,
        LessonsList,
    },
})
export default class UpdateWorksheetTrade extends Vue {
    private filters: LessonsFilter = {
        tags: [],
    };
    private checkedLessons = new Array<Lesson>();
    private topics = new Array<Topic>();
    private filteredTopics = new Array<Topic>();

    private selectedTrade: Trade = {} as Trade;
    private selectedPhase: Phase = {} as Phase;

    private worksheet: Worksheet = {} as Worksheet;
    private isLoading: boolean = false;
    private isReady: boolean = false;

    @Getter('project/selectedProject') private selectedProject: Project;

    @Watch('filters', { deep: true })
    private filterLessons() {
        this.filteredTopics = filterLessonContainer(JSON.parse(JSON.stringify(this.topics)) as Topic[], this.filters);
    }

    get allSelected() {
        return allInLessonContainersSelected(this.filteredTopics, this.checkedLessons);
    }

    private mounted() {
        if (this.$route.query.hasOwnProperty('worksheetId')) {
            this.loadWorksheetById(Number(this.$route.query.worksheetId));
        } else {
            this.goBack();
        }
    }

    private goBack() {
        // Show the Worksheet View
        this.$router.push({
            name: 'WorksheetView',
            query: {
                id: this.worksheet.id.toString(),
                onlyPR: this.$route.query.onlyPR,
                type: this.$route.query.type,
            },
        });
    }

    private loadWorksheetById(worksheetId: number) {
        tradeWorksheetWebservice
            .getById(worksheetId)
            .then((response) => {
                this.worksheet = response.data;
                this.loadLessons();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private loadLessons() {
        // get List With Questions By tradeId With Lessons and phases
        // tslint:disable-next-line:max-line-length
        topicWebservice
            .loadTopicsByTradeAndPhaseWithLessons(
                this.worksheet.trade.id,
                this.worksheet.phase.id,
                ApprovalState.APPROVED
            )
            .then((response) => {
                this.topics = response.data;
                this.filterLessons();
                this.checkCurrentAppliedLessons();
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private checkCurrentAppliedLessons() {
        this.filteredTopics.forEach((topic) => {
            this.selectAllAppliedLessonsRec(topic.lessons, this.checkedLessons);
        });
        this.isReady = true;
    }

    private selectAllAppliedLessonsRec(lessons: Lesson[], checkedLessons) {
        lessons.forEach((lesson: Lesson) => {
            if (this.isAppliedLesson(lesson)) {
                checkedLessons.push(lesson);
            }
            if (lesson.sub_lessons) {
                this.selectAllAppliedLessonsRec(lesson.sub_lessons, checkedLessons);
            }
        });
    }

    private isAppliedLesson(lesson: Lesson) {
        return !!this.worksheet.applied_lessons.find((al) => al.lesson_id === lesson.id);
    }

    private selectAllClick() {
        if (this.allSelected) {
            this.checkedLessons = deselectAll(this.filteredTopics, this.checkedLessons);
        } else {
            this.checkedLessons = selectAll(this.filteredTopics, this.checkedLessons);
        }
    }

    private updateWorksheet() {
        this.isLoading = true;
        tradeWorksheetWebservice
            .update(this.worksheet, this.checkedLessons)
            .then((response) => {
                this.goBack();
            })
            .catch((error) => {
                console.log(error);
                this.isLoading = false;
            });
    }

    private hr(index) {
        return index > 1;
    }
}
